import { createFeatureSelector, createSelector } from '@ngrx/store';

import { COOKIE_CONSENT_FEATURE_KEY, CookieConsentState } from './cookie-consent.reducer';

// Lookup the 'CookieConsent' feature state managed by NgRx
export const getCookieConsentState = createFeatureSelector<CookieConsentState>(COOKIE_CONSENT_FEATURE_KEY);

export const getAcceptanceStatus = createSelector(getCookieConsentState, (state: CookieConsentState) => state.accepted);
